"use client";

import { Suspense, useRef } from "react";

type Props = {
  title: string;
  className?: string;
  children: React.ReactNode;
};

function Button({ title, onClick }: { title: string; onClick?: () => void }) {
  return (
    <button className="btn btn-xs btn-accent link" onClick={onClick}>
      <svg
        tabIndex={0}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        className="h-4 w-4 stroke-current"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        ></path>
      </svg>
      {title && <span>{title}</span>}
    </button>
  );
}
function DiagLogDiv({ children, onClick }: { children: React.ReactNode; onClick?: () => void }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50  h-full" onClick={onClick}>
      <div className="bg-slate-900/90 px-8 sm:px-16 rounded-md border overflow-y-auto w-4/5 lg:w-3/5 h-2/5">
        {children}
      </div>
    </div>
  );
}

function Modal({ title, className, children }: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const openDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  };

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };

  return (
    <div className={className}>
      <Button title={title} onClick={openDialog} />
      <dialog ref={dialogRef} className="modal">
        <DiagLogDiv onClick={closeDialog}>{children}</DiagLogDiv>
      </dialog>
    </div>
  );
}

export function DescriptionModal(props: Props) {
  return (
    <Suspense
      fallback={
        <div className={props.className}>
          <Button title={props.title} />
          <dialog className="modal">
            <DiagLogDiv>{props.children}</DiagLogDiv>
          </dialog>
        </div>
      }
    >
      {<Modal {...props} />}
    </Suspense>
  );
}
